import { Breadcrumb, SimpleCard } from "@gull";
import { RenderSelectInput, RenderTextInput } from "app/common/renderInput";
import usePagePermission from "app/hooks/usePagePermission";
import {
  getAirline,
  getAirport,
  getAirportTimeZone,
  offlineTicket,
} from "app/services/bookingService";
import { FieldArray, Formik } from "formik";
import moment from "moment";
import { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { MdOutlineAdd } from "react-icons/md";
import LaddaButton, { ZOOM_IN } from "react-ladda";
import { NotificationManager } from "react-notifications";
import { useNavigate } from "react-router-dom";
import MemberSearchOfflineTicket from "../Credit Settings/MemberSearchOfflineTicket";
import "../Flight/CreateFlight.css";
import { model, validationSchema } from "./Components/Add/charterFlightModel";
import FlightLegs from "./Components/Add/flightLegs/FlightLegs";
import PaxCard from "./Components/Add/flightLegs/PaxCard";
import PriceCard from "./Components/Add/flightLegs/PriceCard";
import FlightLegsReturn from "./Components/Add/flightLegsReturn/FlightLegsReturn";
import PaxCardReturn from "./Components/Add/flightLegsReturn/PaxCardReturn";
import PriceCardReturn from "./Components/Add/flightLegsReturn/PriceCardReturn";
import PreviewModal from "./Components/Add/PreviewModal";
import { DateTime } from "luxon";

const AddTicket = () => {
  const navigate = useNavigate();
  const { canAdd } = usePagePermission();
  const [state, setState] = useState({
    model,
  });
  const [affiliateResponse, setAffiliateResponse] = useState(null);
  const [response, setResponse] = useState(null);
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const tripTypeOptions = [
    { value: "1", label: "One Way" },
    { value: "2", label: "Domestic Return" },
    { value: "3", label: "International Return" },
  ];
  const flightTypeOptions = [
    { value: "Domestic", label: "Domestic" },
    { value: "International", label: "International" },
    // { value: 3, label: "Combo" },
  ];
  const airlinesDetails = async (values) => {
    const data = await getAirline(values?.airline);

    const model = {
      aI: {
        code: data.flightcarrierCode,
        name: data.flightCarrierName,
        isLcc: false,
      },
      fN: values?.fN,
    };
    return model;
  };

  const airportDetails = async (id, terminal) => {
    const data = await getAirport(id);

    const model = {
      code: data.cityCode,
      name: data.airportName,
      cityCode: data.cityCode,
      city: data.cityName,
      country: data.countryCode == "IN" ? "India" : data.countryCode,
      countryCode: data.countryCode,
      terminal: terminal,
    };

    return model;
  };

  const paxDetails = (value, seg) => {
    const pax =
      seg.pt == "ADULT" ? "ADULT" : seg.pt == "CHILD" ? "CHILD" : "INFANT";
    const model = {
      [pax]: {
        fC: {
          BF:
            seg.pt == "ADULT"
              ? Number(value.onwardAdultBF)
              : seg.pt == "CHILD"
                ? Number(value.onwardChildBF)
                : Number(value.onwardInfantBF),
          TF:
            seg.pt == "ADULT"
              ? Number(value.onwardAdultTF)
              : seg.pt == "CHILD"
                ? Number(value.onwardChildTF)
                : Number(value.onwardInfantTF),
          TAF:
            seg.pt == "ADULT"
              ? Number(value.onwardAdultTAF)
              : seg.pt == "CHILD"
                ? Number(value.onwardChildTAF)
                : Number(value.onwardInfantTAF),
          NF:
            seg.pt == "ADULT"
              ? Number(value.onwardAdultNF)
              : seg.pt == "CHILD"
                ? Number(value.onwardChildNF)
                : Number(value.onwardInfantNF),
        },
        afC: {
          NCM: {
            OT:
              seg.pt == "ADULT"
                ? Number(value.onwardAdultDiscountWithGst)
                : seg.pt == "CHILD"
                  ? Number(value.onwardChildDiscountWithGst)
                  : Number(value.onwardInfantDiscountWithGst),
            TDS:
              seg.pt == "ADULT"
                ? -Number(value.onwardAdultTds)
                : seg.pt == "CHILD"
                  ? -Number(value.onwardChildTds)
                  : -Number(value.onwardInfantTds),
            comPercentage:
              seg.pt == "ADULT"
                ? Number(value.onwardAdultPercentage)
                : seg.pt == "CHILD"
                  ? Number(value.onwardChildPercentage)
                  : Number(value.onwardInfantPercentage),
          },
        },
        sR: 0,
        bI: {
          iB: seg.checkingBag,
          cB: seg.cabinBag,
        },
        rT: Number(seg.refundable),
        cc: seg.cc,
        cB: seg.cB,
      },
    };

    return model;
  };

  const paxDetailsReturn = (value, seg) => {
    const pax =
      seg.pt == "ADULT" ? "ADULT" : seg.pt == "CHILD" ? "CHILD" : "INFANT";
    const model = {
      [pax]: {
        fC: {
          BF:
            seg.pt == "ADULT"
              ? Number(value.returnAdultBF)
              : seg.pt == "CHILD"
                ? Number(value.returnChildBF)
                : Number(value.returnInfantBF),
          TF:
            seg.pt == "ADULT"
              ? Number(value.returnAdultTF)
              : seg.pt == "CHILD"
                ? Number(value.returnChildTF)
                : Number(value.returnInfantTF),
          TAF:
            seg.pt == "ADULT"
              ? Number(value.returnAdultTAF)
              : seg.pt == "CHILD"
                ? Number(value.returnChildTAF)
                : Number(value.returnInfantTAF),
          NF:
            seg.pt == "ADULT"
              ? Number(value.returnAdultNF)
              : seg.pt == "CHILD"
                ? Number(value.returnChildNF)
                : Number(value.returnInfantNF),
        },
        afC: {
          NCM: {
            OT:
              seg.pt == "ADULT"
                ? Number(value.returnAdultDiscountWithGst)
                : seg.pt == "CHILD"
                  ? Number(value.returnChildDiscountWithGst)
                  : Number(value.returnInfantDiscountWithGst),
            TDS:
              seg.pt == "ADULT"
                ? -Number(value.returnAdultTds)
                : seg.pt == "CHILD"
                  ? -Number(value.returnChildTds)
                  : -Number(value.returnInfantTds),
            comPercentage:
              seg.pt == "ADULT"
                ? Number(value.returnAdultPercentage)
                : seg.pt == "CHILD"
                  ? Number(value.returnChildPercentage)
                  : Number(value.returnInfantPercentage),
          },
        },
        sR: 0,
        bI: {
          iB: seg.checkingBag,
          cB: seg.cabinBag,
        },
        rT: Number(seg.refundable),
        cc: seg.cc,
        cB: seg.cB,
      },
    };

    return model;
  };
  //airlines PNR
  const buildAirlinesPnrMap = (tripInfos) => {
    let pnr = {};

    tripInfos?.forEach((trip) => {
      trip?.sI?.forEach((seg) => {
        if (seg.airlinesPnr) {
          const codePnr = `${seg.da.code}-${seg.aa.code}`;
          pnr[codePnr] = seg.airlinesPnr;
        }
      });
    });

    return Object.keys(pnr).length ? pnr : null;
  };
  //Ticket Number
  const buildTicketMap = (pax, tripInfos, tripIndex) => {
    let ticketNo = {};

    tripInfos[tripIndex]?.sI?.forEach((seg) => {
      if (pax.ticketNo) {
        const codePnr = `${seg.da.code}-${seg.aa.code}`;

        ticketNo[codePnr] = pax.ticketNo;
      }
    });

    return Object.keys(ticketNo).length ? ticketNo : null;
  };

  const ssrInnerBinding = (boundSegments, flightSegment, id, ssrSegment) => {
    flightSegment.tripInfos[id].sI.forEach((item, index) => {
      const codePnr = `${item.da.code}-${item.aa.code}`;

      if (ssrSegment && ssrSegment[index]) {
        // Check if binding exists for the index
        boundSegments[codePnr] = {
          code: ssrSegment[index].code || "",
          amount: Number(ssrSegment[index].amount) || 0,
          desc: ssrSegment[index].code || "",
        };
      } else {
      }
    });

    return boundSegments; // Return the bound segments
  };

  const ssrBinding = (
    flightSegment,
    ssrSegmentType,
    values,
    journeyType,
    paxId,
  ) => {
    debugger;
    const boundSegmentsOnward = {};
    const boundSegmentsReturn = {};

    // Helper function to choose the correct segment array based on type
    const getSegmentArray = (seg, type) => {
      switch (type) {
        case "extraBag":
          return seg.extraBag;
        case "seat":
          return seg.seat;
        case "food":
          return seg.food;
        case "fast":
          return seg.fast;
        default:
          return [];
      }
    };

    const segmentArray = getSegmentArray(values.onward[paxId], ssrSegmentType);
    if (segmentArray && segmentArray?.length > 0) {
      const result = ssrInnerBinding(
        boundSegmentsOnward,
        flightSegment,
        0,
        segmentArray,
      );
      Object.assign(boundSegmentsOnward, result); // Mutate instead of reassigning
    }

    if (journeyType == "2" || journeyType == "3") {
      const segmentArrayReturn = getSegmentArray(
        values.return[paxId],
        ssrSegmentType,
      );
      if (segmentArrayReturn && segmentArrayReturn?.length > 0) {
        const result = ssrInnerBinding(
          boundSegmentsReturn,
          flightSegment,
          1,
          segmentArrayReturn,
        );
        Object.assign(boundSegmentsReturn, result); // Mutate instead of reassigning
      }
    }

    const boundSegments =
      journeyType == "1"
        ? boundSegmentsOnward
        : {
            ...boundSegmentsOnward,
            ...boundSegmentsReturn,
          };

    return boundSegments;
  };

  const calculateSSRAmount = (value) => {
    return value?.reduce((total, passenger) => {
      const foodTotal = passenger?.food?.reduce(
        (sum, item) => sum + parseFloat(item.amount || 0),
        0,
      );
      const extraBagTotal = passenger?.extraBag?.reduce(
        (sum, item) => sum + parseFloat(item.amount || 0),
        0,
      );
      const seatTotal = passenger?.seat?.reduce(
        (sum, item) => sum + parseFloat(item.amount || 0),
        0,
      );
      const fastTotal = passenger?.fast?.reduce(
        (sum, item) => sum + parseFloat(item.amount || 0),
        0,
      );
      const passengerTotal =
        (foodTotal ?? 0) +
        (extraBagTotal ?? 0) +
        (seatTotal ?? 0) +
        (fastTotal ?? 0);

      return (total ?? 0) + (passengerTotal ?? 0) ?? 0;
    }, 0);
  };
  const frequentFlyer = (value, paxId, airlines) => {
    if (!value || !airlines?.length) return null;

    const onwardFF = value.pax?.onward?.[paxId]?.ff;
    const returnFF = value.pax?.return?.[paxId]?.ff;

    const result = {};

    // Onward segment (first airline)
    const onwardAirlineCode = airlines?.[0]?.sI?.[0]?.fD?.aI?.code;
    if (onwardFF && onwardAirlineCode) {
      result[onwardAirlineCode] = onwardFF;
    }

    // Return segment (second airline, if available)
    const returnAirlineCode = airlines?.[1]?.sI?.[0]?.fD?.aI?.code;
    if (returnFF && returnAirlineCode) {
      result[returnAirlineCode] = returnFF;
    }

    return Object.keys(result).length > 0 ? result : null;
  };
  const timeZone = async (value) => {
    try {
      // Ensure value is in uppercase

      const res = await getAirportTimeZone(value.toUpperCase());
      return res.timezone || "Asia/Kolkata";
    } catch (e) {
      return "Asia/Kolkata"; // in case of error
    }
  };
  const submitForm = async (values) => {
    ////Review Response

    const model = [];
    let reviewModel = {
      tripInfos: [],
      searchQuery: {},
      bookingId: values.bookingId,
      totalPriceInfo: {},
      conditions: "",
    };
    let paxDetailsPrice = {};
    let paxDetailsPriceReturn = {};
    values.pax.onward.map(async (seg, id) => {
      let res = paxDetails(values, seg);
      paxDetailsPrice =
        Object.keys(paxDetailsPrice).length > 0
          ? { ...paxDetailsPrice, ...res }
          : { ...res };
    });
    // console.log(paxDetailsPrice, "paxDetailsPrice");
    values.pax.return.map(async (seg, id) => {
      let res = paxDetailsReturn(values, seg);
      paxDetailsPriceReturn =
        Object.keys(paxDetailsPriceReturn).length > 0
          ? { ...paxDetailsPriceReturn, ...res }
          : { ...res };
    });

    if (values.tripType == "1") {
      model.push({
        sI: await Promise.all(
          values.flightLegs.onward.map(async (seg, id, array) => {
            const airlineData = await airlinesDetails(seg);
            const airportDept = await airportDetails(
              seg.airportDepartureId,
              seg.airportDepartureTerminal,
            );
            const airportArrival = await airportDetails(
              seg.airportDestinationId,
              seg.airportDestinationTerminal,
            );

            // departure & arrival zones
            const departureZone = await timeZone(airportDept.cityCode);
            const arrivalZone = await timeZone(airportArrival.cityCode);

            // combine date + time → ISO
            const departureISO = `${seg.departureDate}T${seg.departureTime}`;
            const arrivalISO = `${seg.arrivalDate}T${seg.arrivalTime}`;

            // Luxon datetime objects
            const departure = DateTime.fromISO(departureISO, {
              zone: departureZone,
            });
            const arrival = DateTime.fromISO(arrivalISO, { zone: arrivalZone });

            // duration in minutes
            const durationInMinutes = arrival
              .diff(departure, ["minutes"])
              .toObject().minutes;

            // layover (connecting time) — only if not the last segment
            let layoverTime = null;
            if (id < array.length - 1) {
              const nextSegment = array[id + 1];
              const nextDepartureAirport = await airportDetails(
                nextSegment.airportDepartureId,
                nextSegment.airportDepartureTerminal,
              );
              const nextDepartureZone = await timeZone(
                nextDepartureAirport.cityCode,
              );

              const nextDepartureISO = `${nextSegment.departureDate}T${nextSegment.departureTime}`;
              const nextDeparture = DateTime.fromISO(nextDepartureISO, {
                zone: nextDepartureZone,
              });

              layoverTime = nextDeparture
                .diff(arrival, ["minutes"])
                .toObject().minutes;
            }

            return {
              id: id,
              fD: airlineData,
              dt: `${seg.departureDate}T${seg.departureTime}`,
              at: `${seg.arrivalDate}T${seg.arrivalTime}`,
              da: airportDept,
              aa: airportArrival,
              duration: durationInMinutes,
              cT: id == array.length - 1 ? null : layoverTime,
              iand: false,
              isRs: false,
              sN: id,
              stops: 0,
              airlinesPnr: seg.pnr,
              ticketNo: seg.ticketNo,
              gdsPnr: seg.gdsPnr != "" ? seg.gdsPnr : null,
            };
          }),
        ),
        totalPriceList: [
          {
            fd: paxDetailsPrice,
            fareIdentifier: "",
            id: "",
          },
        ],
      });
    } else if (values.tripType == "2") {
      model.push(
        {
          sI: await Promise.all(
            values.flightLegs.onward.map(async (seg, id, array) => {
              const airlineData = await airlinesDetails(seg);
              const airportDept = await airportDetails(
                seg.airportDepartureId,
                seg.airportDepartureTerminal,
              );
              const airportArrival = await airportDetails(
                seg.airportDestinationId,
                seg.airportDestinationTerminal,
              );

              // departure & arrival zones
              const departureZone = await timeZone(airportDept.cityCode);
              const arrivalZone = await timeZone(airportArrival.cityCode);

              // combine date + time → ISO
              const departureISO = `${seg.departureDate}T${seg.departureTime}`;
              const arrivalISO = `${seg.arrivalDate}T${seg.arrivalTime}`;

              // Luxon datetime objects
              const departure = DateTime.fromISO(departureISO, {
                zone: departureZone,
              });
              const arrival = DateTime.fromISO(arrivalISO, {
                zone: arrivalZone,
              });

              // duration in minutes
              const durationInMinutes = arrival
                .diff(departure, ["minutes"])
                .toObject().minutes;

              // layover (connecting time) — only if not the last segment
              let layoverTime = null;
              if (id < array.length - 1) {
                const nextSegment = array[id + 1];
                const nextDepartureAirport = await airportDetails(
                  nextSegment.airportDepartureId,
                  nextSegment.airportDepartureTerminal,
                );
                const nextDepartureZone = await timeZone(
                  nextDepartureAirport.cityCode,
                );

                const nextDepartureISO = `${nextSegment.departureDate}T${nextSegment.departureTime}`;
                const nextDeparture = DateTime.fromISO(nextDepartureISO, {
                  zone: nextDepartureZone,
                });

                layoverTime = nextDeparture
                  .diff(arrival, ["minutes"])
                  .toObject().minutes;
              }

              return {
                id: id,
                fD: airlineData,
                dt: `${seg.departureDate}T${seg.departureTime}`,
                at: `${seg.arrivalDate}T${seg.arrivalTime}`,
                da: airportDept,
                aa: airportArrival,
                duration: durationInMinutes,
                cT: id == array.length - 1 ? null : layoverTime,
                iand: false,
                isRs: false,
                sN: id,
                stops: 0,
                airlinesPnr: seg.pnr,
                ticketNo: seg.ticketNo,
                gdsPnr: seg.gdsPnr != "" ? seg.gdsPnr : null,
              };
            }),
          ),
          totalPriceList: [
            {
              fd: paxDetailsPrice,
              fareIdentifier: "",
              id: "",
            },
          ],
        },
        {
          sI: await Promise.all(
            values.flightLegs.return.map(async (seg, id, array) => {
              const airlineData = await airlinesDetails(seg);
              const airportDept = await airportDetails(
                seg.airportDepartureId,
                seg.airportDepartureTerminal,
              );
              const airportArrival = await airportDetails(
                seg.airportDestinationId,
                seg.airportDestinationTerminal,
              );

              // departure & arrival zones
              const departureZone = await timeZone(airportDept.cityCode);
              const arrivalZone = await timeZone(airportArrival.cityCode);

              // combine date + time → ISO
              const departureISO = `${seg.departureDate}T${seg.departureTime}`;
              const arrivalISO = `${seg.arrivalDate}T${seg.arrivalTime}`;

              // Luxon datetime objects
              const departure = DateTime.fromISO(departureISO, {
                zone: departureZone,
              });
              const arrival = DateTime.fromISO(arrivalISO, {
                zone: arrivalZone,
              });

              // duration in minutes
              const durationInMinutes = arrival
                .diff(departure, ["minutes"])
                .toObject().minutes;

              // layover (connecting time) — only if not the last segment
              let layoverTime = null;
              if (id < array.length - 1) {
                const nextSegment = array[id + 1];
                const nextDepartureAirport = await airportDetails(
                  nextSegment.airportDepartureId,
                  nextSegment.airportDepartureTerminal,
                );
                const nextDepartureZone = await timeZone(
                  nextDepartureAirport.cityCode,
                );

                const nextDepartureISO = `${nextSegment.departureDate}T${nextSegment.departureTime}`;
                const nextDeparture = DateTime.fromISO(nextDepartureISO, {
                  zone: nextDepartureZone,
                });

                layoverTime = nextDeparture
                  .diff(arrival, ["minutes"])
                  .toObject().minutes;
              }

              return {
                id: id,
                fD: airlineData,
                dt: `${seg.departureDate}T${seg.departureTime}`,
                at: `${seg.arrivalDate}T${seg.arrivalTime}`,
                da: airportDept,
                aa: airportArrival,
                duration: durationInMinutes,
                cT: id == array.length - 1 ? null : layoverTime,
                iand: false,
                isRs: false,
                sN: id,
                stops: 0,
                airlinesPnr: seg.pnr,
                ticketNo: seg.ticketNo,
                gdsPnr: seg.gdsPnr != "" ? seg.gdsPnr : null,
              };
            }),
          ),
          totalPriceList: [
            {
              fd: paxDetailsPriceReturn,
              fareIdentifier: "",
              id: "",
            },
          ],
        },
      );
    } else {
      model.push(
        {
          sI: await Promise.all(
            values.flightLegs.onward.map(async (seg, id, array) => {
              const airlineData = await airlinesDetails(seg);
              const airportDept = await airportDetails(
                seg.airportDepartureId,
                seg.airportDepartureTerminal,
              );
              const airportArrival = await airportDetails(
                seg.airportDestinationId,
                seg.airportDestinationTerminal,
              );

              // departure & arrival zones
              const departureZone = await timeZone(airportDept.cityCode);
              const arrivalZone = await timeZone(airportArrival.cityCode);

              // combine date + time → ISO
              const departureISO = `${seg.departureDate}T${seg.departureTime}`;
              const arrivalISO = `${seg.arrivalDate}T${seg.arrivalTime}`;

              // Luxon datetime objects
              const departure = DateTime.fromISO(departureISO, {
                zone: departureZone,
              });
              const arrival = DateTime.fromISO(arrivalISO, {
                zone: arrivalZone,
              });

              // duration in minutes
              const durationInMinutes = arrival
                .diff(departure, ["minutes"])
                .toObject().minutes;

              // layover (connecting time) — only if not the last segment
              let layoverTime = null;
              if (id < array.length - 1) {
                const nextSegment = array[id + 1];
                const nextDepartureAirport = await airportDetails(
                  nextSegment.airportDepartureId,
                  nextSegment.airportDepartureTerminal,
                );
                const nextDepartureZone = await timeZone(
                  nextDepartureAirport.cityCode,
                );

                const nextDepartureISO = `${nextSegment.departureDate}T${nextSegment.departureTime}`;
                const nextDeparture = DateTime.fromISO(nextDepartureISO, {
                  zone: nextDepartureZone,
                });

                layoverTime = nextDeparture
                  .diff(arrival, ["minutes"])
                  .toObject().minutes;
              }
              return {
                id: id,
                fD: airlineData,
                dt: `${seg.departureDate}T${seg.departureTime}`,
                at: `${seg.arrivalDate}T${seg.arrivalTime}`,
                da: airportDept,
                aa: airportArrival,
                duration: durationInMinutes,
                cT: id == array.length - 1 ? null : layoverTime,
                iand: false,
                isRs: false,
                sN: id,
                stops: 0,
                airlinesPnr: seg.pnr,
                ticketNo: seg.ticketNo,
                gdsPnr: seg.gdsPnr != "" ? seg.gdsPnr : null,
              };
            }),
          ),
          totalPriceList: [
            {
              fd: paxDetailsPrice,
              fareIdentifier: "",
              id: "",
            },
          ],
        },
        {
          sI: await Promise.all(
            values.flightLegs.return.map(async (seg, id, array) => {
              const airlineData = await airlinesDetails(seg);
              const airportDept = await airportDetails(
                seg.airportDepartureId,
                seg.airportDepartureTerminal,
              );
              const airportArrival = await airportDetails(
                seg.airportDestinationId,
                seg.airportDestinationTerminal,
              );

              // departure & arrival zones
              const departureZone = await timeZone(airportDept.cityCode);
              const arrivalZone = await timeZone(airportArrival.cityCode);

              // combine date + time → ISO
              const departureISO = `${seg.departureDate}T${seg.departureTime}`;
              const arrivalISO = `${seg.arrivalDate}T${seg.arrivalTime}`;

              // Luxon datetime objects
              const departure = DateTime.fromISO(departureISO, {
                zone: departureZone,
              });
              const arrival = DateTime.fromISO(arrivalISO, {
                zone: arrivalZone,
              });

              // duration in minutes
              const durationInMinutes = arrival
                .diff(departure, ["minutes"])
                .toObject().minutes;

              // layover (connecting time) — only if not the last segment
              let layoverTime = null;
              if (id < array.length - 1) {
                const nextSegment = array[id + 1];
                const nextDepartureAirport = await airportDetails(
                  nextSegment.airportDepartureId,
                  nextSegment.airportDepartureTerminal,
                );
                const nextDepartureZone = await timeZone(
                  nextDepartureAirport.cityCode,
                );

                const nextDepartureISO = `${nextSegment.departureDate}T${nextSegment.departureTime}`;
                const nextDeparture = DateTime.fromISO(nextDepartureISO, {
                  zone: nextDepartureZone,
                });

                layoverTime = nextDeparture
                  .diff(arrival, ["minutes"])
                  .toObject().minutes;
              }
              return {
                id: id,
                fD: airlineData,
                dt: `${seg.departureDate}T${seg.departureTime}`,
                at: `${seg.arrivalDate}T${seg.arrivalTime}`,
                da: airportDept,
                aa: airportArrival,
                duration: durationInMinutes,
                cT: id == array.length - 1 ? null : layoverTime,
                iand: false,
                isRs: false,
                sN: id,
                stops: 0,
                airlinesPnr: seg.pnr,
                ticketNo: seg.ticketNo,
                gdsPnr: seg.gdsPnr != "" ? seg.gdsPnr : null,
              };
            }),
          ),
          totalPriceList: [
            {
              fd: paxDetailsPriceReturn,
              fareIdentifier: "",
              id: "",
            },
          ],
        },
      );
    }
    const paxInfo = {
      ADULT: Number(values.adults),
      CHILD: Number(values.child),
      INFANT: Number(values.infant),
    };
    const fC = {
      BF: getBaseFare(
        paxDetailsPrice,
        values.tripType,
        paxDetailsPriceReturn,
        paxInfo,
      ),
      TF: totalFare(
        paxDetailsPrice,
        values.tripType,
        paxDetailsPriceReturn,
        paxInfo,
      ),
      TAF: getTotalTax(
        paxDetailsPrice,
        values.tripType,
        paxDetailsPriceReturn,
        paxInfo,
      ),
      NF: netFare(
        paxDetailsPrice,
        values.tripType,
        paxDetailsPriceReturn,
        paxInfo,
      ),
    };
    const afC = {
      NCM: {
        OT: totalOriginalDiscount(
          paxDetailsPrice,
          values.tripType,
          paxDetailsPriceReturn,
          paxInfo,
        ),
        TDS: -totalTdsForTJ(
          paxDetailsPrice,
          values.tripType,
          paxDetailsPriceReturn,
          paxInfo,
        ),
      },
    };
    let routeInfos = [];
    if (values.tripType == "1") {
      routeInfos.push({
        fromCityOrAirport: model[0].sI[0].da,
        toCityOrAirport: model[0].sI[model[0].sI.length - 1].aa,
        travelDate: model[0].sI[0].dt,
      });
    } else {
      routeInfos.push(
        {
          fromCityOrAirport: model[0].sI[0].da,
          toCityOrAirport: model[0].sI[model[0].sI.length - 1].aa,
          travelDate: model[0].sI[0].dt,
        },
        {
          fromCityOrAirport: model[1].sI[0].da,
          toCityOrAirport: model[1].sI[model[1].sI.length - 1].aa,
          travelDate: model[1].sI[0].dt,
        },
      );
    }
    reviewModel.tripInfos = model;
    reviewModel.totalPriceInfo = {
      totalFareDetail: {
        fC,
        afC,
      },
    };

    reviewModel.searchQuery = {
      routeInfos,
      paxInfo,
      searchType: values.tripType == "1" ? "ONEWAY" : "RETURN",
      isDomestic: values.flightType == "Domestic" ? true : false,
    };

    /////PNR response Structure Build

    /* start region airlines PNR */
    const pnr = buildAirlinesPnrMap(reviewModel.tripInfos);
    /* end region */

    /* start region GDS PNR */
    const pnrGdsObj = reviewModel.tripInfos.reduce((acc, trip) => {
      trip.sI.forEach((seg) => {
        if (seg.gdsPnr) {
          const codePnr = `${seg.da.code}-${seg.aa.code}`;
          acc[codePnr] = seg.gdsPnr;
        }
      });
      return acc;
    }, {});

    const pnrGds = Object.keys(pnrGdsObj).length ? pnrGdsObj : null;
    /* end region */

    /*start ticket Number */
    const onwardPax = values.pax.onward.map((pax) => ({
      ticketNumberDetails: buildTicketMap(pax, reviewModel.tripInfos, 0),
    }));
    const returnPax =
      values?.pax?.return?.map((pax) => ({
        ticketNumberDetails: buildTicketMap(pax, reviewModel.tripInfos, 1),
      })) || [];
    /*end ticket Number */

    let pnrModel = {
      order: {
        bookingId: values.bookingId,
        amount: reviewModel.totalPriceInfo.totalFareDetail.fC.NF,
        markup: 0,
        orderType: "AIR",
        // deliveryInfo,
        status: "SUCCESS",
        createdOn: moment().format(),
      },
      itemInfos: {
        AIR: {
          tripInfos: reviewModel.tripInfos,
          travellerInfos: await Promise.all(
            values.pax.onward.map(async (seg, id) => {
              const mergedDetails = {
                ...(onwardPax[id]?.ticketNumberDetails || {}),
                ...(returnPax[id]?.ticketNumberDetails || {}),
              };

              const travellerInfo = {
                pnrDetails: pnr,
                ti: seg.ti,
                pt: seg.pt,
                fN: seg.fN,
                lN: seg.lN,
                id: id + 1,
                ssrWheelchair: seg?.Wheelchair,
                ff: frequentFlyer(values, id, reviewModel.tripInfos),
              };
              debugger;
              // Conditionally bind optional fields
              // ✅ Only set when data exists
              if (Object.keys(mergedDetails).length > 0) {
                travellerInfo.ticketNumberDetails = mergedDetails;
              }
              if (pnrGds != null) {
                travellerInfo.gdsPnrs = pnrGds;
              }
              if (seg.dob) {
                travellerInfo.dob = seg.dob;
              }
              if (seg.pNum && values.flightType !== "Domestic") {
                travellerInfo.pNum = seg.pNum;
              }
              if (seg.eD && values.flightType !== "Domestic") {
                travellerInfo.eD = seg.eD;
              }
              if (seg.pid && values.flightType !== "Domestic") {
                travellerInfo.pid = seg.pid;
              }

              if (values.flightType !== "Domestic" && seg.pNat) {
                travellerInfo.pNat = seg.pNat;
              }
              // Conditionally add these fields only if they exist and have valid content
              if (Array.isArray(seg?.extraBag) && seg.extraBag.length > 0) {
                travellerInfo.ssrBaggageInfos = ssrBinding(
                  reviewModel,
                  "extraBag",
                  values.pax,
                  values.tripType,
                  id,
                );
              }

              if (Array.isArray(seg?.seat) && seg.seat.length > 0) {
                travellerInfo.ssrSeatInfos = ssrBinding(
                  reviewModel,
                  "seat",
                  values.pax,
                  values.tripType,
                  id,
                );
              }

              if (Array.isArray(seg?.food) && seg.food.length > 0) {
                travellerInfo.ssrMealInfos = ssrBinding(
                  reviewModel,
                  "food",
                  values.pax,
                  values.tripType,
                  id,
                );
              }
              if (Array.isArray(seg?.fast) && seg.fast.length > 0) {
                travellerInfo.ssrFastForwardInfos = ssrBinding(
                  reviewModel,
                  "fast",
                  values.pax,
                  values.tripType,
                  id,
                );
              }

              return travellerInfo;
            }),
          ),
          totalPriceInfo: {
            totalFareDetail: {
              fC,
              afC,
            },
          },
        },
      },

      gstInfo: {},
      status: {},
    };

    /* end region */

    /* start region Api Request*/

    // console.log(reviewModel, "review");
    // console.log(pnrModel, "PNr");

    //Airlines Markup onward Flight
    const onwardAirlinesMarkupCal =
      values.airlinesMarkupCom == "Positive"
        ? Number(values.airlinesMarkup)
        : -Number(values.airlinesMarkup);
    //Airlines Markup Return Flight
    const returnAirlinesMarkupCal =
      values.airlinesMarkupComReturn == "Positive"
        ? Number(values.airlinesMarkupReturn)
        : -Number(values.airlinesMarkupReturn);
    ///API request
    const sendRequest = {
      supplierName: values?.supplierName?.toUpperCase(),
      bookingId: values.bookingId,
      reviewResponse: JSON.stringify(reviewModel),
      pnRresponse: JSON.stringify(pnrModel),
      memId: values.affiliateName,
      journeyType: values.tripType,
      bookingType: "OFFLINE",
      userMarkup: Number(values.userMarkup) * paxCount(paxInfo),
      // adminMarkup: Number(values.adminMarkup) * paxCount(paxInfo),
      adminMarkup: Number(values.adminMarkup),
      isDomestic: values.flightType == "Domestic" ? true : false,
      departureDate: model[0].sI[0].dt,
      arrivalDate: model[0].sI[model[0].sI.length - 1].at,
      airlinesMarkup: totalDiscountOnward(values),
      onewayFlightMarkup: values.airlinesMarkupCom,

      returnFlightMarkup:
        values.tripType == "1" ? "" : values.airlinesMarkupComReturn,
      returnFlightMarkupValue:
        values.tripType == "1" ? 0 : totalDiscountReturn(values),

      onewayBookingAmount:
        netFareHandler(paxDetailsPrice, paxInfo) + values.adminMarkup,
        // values.adminMarkup * paxCount(paxInfo),
      // +
      // onwardAirlinesMarkupCal,
      returnBookingAmount:
        values.tripType == "1"
          ? // || values.tripType == "3"
            0
          : netFareHandler(paxDetailsPriceReturn, paxInfo) +
            // +
            //   returnAirlinesMarkupCal
            // values.adminMarkup * paxCount(paxInfo),
            values.adminMarkup,

      bookingReferenceNumber: values.bookingReferenceNumber,
      gstAmount: totalGstCommOnward(values),
      tdsAmount: totalTdsOnward(values),
      retGstAmount: values.tripType == "1" ? 0 : totalGstCommReturn(values),
      retTdsAmount: values.tripType == "1" ? 0 : totalTdsReturn(values),
      gstInfo: values?.gstInfo,

      ssrAmount: calculateSSRAmount(values.pax.onward),
      returnSSRAmount:
        values.tripType == "1" ? 0 : calculateSSRAmount(values.pax.return),
      oneCommWithGst: totalDiscountOnwardWithGST(values),
      retCommWithGst:
        values.tripType == "1" ? 0 : totalDiscountReturnWithGST(values),
    };

    // console.log(sendRequest, "sendRequest");
    setResponse(sendRequest);

    if (sendRequest) {
      setShow(true);
    }
  };
  const offlineBooking = async (response, values) => {
    // console.log(response);
    setIsLoading(true);
    try {
      debugger;
      const bookingAmount =
        response.onewayBookingAmount + response.returnBookingAmount;
      if (values.balance >= bookingAmount) {
        const data = await offlineTicket(response);
        // console.log(data);
        if (data.status == "Success") {
          navigate("/admin/flight/booking-history");
          NotificationManager.success(data.message);
        } else {
          NotificationManager.error(data.message);
        }
      } else {
        NotificationManager.error("Insufficient Merchant Balance");
      }
    } catch (error) {
      NotificationManager.error("Please Contact Your Administrator");
    } finally {
      setIsLoading(false);
    }
  };

  const totalFare = (values, tripType, valuesReturn, paxInfo) => {
    const adultTax =
      parseFloat(
        (values?.ADULT?.fC?.TF +
          (tripType == "1" ? 0 : valuesReturn?.ADULT?.fC?.TF)) *
          paxInfo?.ADULT,
      ) || 0;
    const childTax =
      parseFloat(
        (values?.CHILD?.fC?.TF +
          (tripType == "1" ? 0 : valuesReturn?.CHILD?.fC?.TF)) *
          paxInfo?.CHILD,
      ) || 0;
    const infantTax =
      parseFloat(
        (values?.INFANT?.fC?.TF +
          (tripType == "1" ? 0 : valuesReturn?.INFANT?.fC?.TF)) *
          paxInfo?.INFANT,
      ) || 0;
    const totalFare = Number(adultTax + childTax + infantTax).toFixed(2);
    return Number(totalFare);
  };
  const netFare = (values, tripType, valuesReturn, paxInfo) => {
    const adultTax =
      parseFloat(
        (values?.ADULT?.fC?.NF +
          (tripType == "1" ? 0 : valuesReturn?.ADULT?.fC?.NF)) *
          paxInfo?.ADULT,
      ) || 0;
    const childTax =
      parseFloat(
        (values?.CHILD?.fC?.NF +
          (tripType == "1" ? 0 : valuesReturn?.CHILD?.fC?.NF)) *
          paxInfo?.CHILD,
      ) || 0;
    const infantTax =
      parseFloat(
        (values?.INFANT?.fC?.NF +
          (tripType == "1" ? 0 : valuesReturn?.INFANT?.fC?.NF)) *
          paxInfo?.INFANT,
      ) || 0;
    const totalFare = Number(adultTax + childTax + infantTax).toFixed(2);
    return Number(totalFare);
  };

  const getTotalTax = (values, tripType, valuesReturn, paxInfo) => {
    const adultTax =
      parseFloat(
        (values?.ADULT?.fC?.TAF +
          (tripType == "1" ? 0 : valuesReturn?.ADULT?.fC?.TAF)) *
          paxInfo?.ADULT,
      ) || 0;
    const childTax =
      parseFloat(
        (values?.CHILD?.fC?.TAF +
          (tripType == "1" ? 0 : valuesReturn?.CHILD?.fC?.TAF)) *
          paxInfo?.CHILD,
      ) || 0;
    const infantTax =
      parseFloat(
        (values?.INFANT?.fC?.TAF +
          (tripType == "1" ? 0 : valuesReturn?.INFANT?.fC?.TAF)) *
          paxInfo?.INFANT,
      ) || 0;

    // Perform addition
    const totalFare = Number(adultTax + childTax + infantTax).toFixed(2);

    // Return the result
    return Number(totalFare);
  };

  const getBaseFare = (values, tripType, valuesReturn, paxInfo) => {
    const adultTax =
      parseFloat(
        (Number(values?.ADULT?.fC?.BF) +
          (tripType == "1" ? 0 : valuesReturn?.ADULT?.fC?.BF)) *
          paxInfo?.ADULT,
      ) || 0;
    const childTax =
      parseFloat(
        (Number(values?.CHILD?.fC?.BF) +
          (tripType == "1" ? 0 : valuesReturn?.CHILD?.fC?.BF)) *
          paxInfo?.CHILD,
      ) || 0;
    const infantTax =
      parseFloat(
        (Number(values?.INFANT?.fC?.BF) +
          (tripType == "1" ? 0 : valuesReturn?.INFANT?.fC?.BF)) *
          paxInfo?.INFANT,
      ) || 0;

    // Perform addition
    const totalFare = Number(adultTax + childTax + infantTax).toFixed(2);

    // Return the result
    return Number(totalFare);
  };
  const netFareHandler = (fare, paxInfo) => {
    const adultTax = Number(fare?.ADULT?.fC?.NF * paxInfo?.ADULT) || 0;
    const childTax = Number(fare?.CHILD?.fC?.NF * paxInfo?.CHILD) || 0;
    const infantTax = Number(fare?.INFANT?.fC?.NF * paxInfo?.INFANT) || 0;
    const totalFare = Number(adultTax + childTax + infantTax).toFixed(2);
    return Number(totalFare);
  };
  const paxCount = (paxInfo) => {
    const adult = Number(paxInfo?.ADULT) || 0;
    const child = Number(paxInfo?.CHILD) || 0;
    const infant = Number(paxInfo?.INFANT) || 0;
    const totalFare = adult + child + infant;
    return totalFare;
  };

  const totalOriginalDiscount = (values, tripType, valuesReturn, paxInfo) => {
    const adultFare =
      parseFloat(
        (Number(values?.ADULT?.afC?.NCM?.OT) +
          (tripType == "1" ? 0 : valuesReturn?.ADULT?.afC?.NCM?.OT)) *
          paxInfo?.ADULT,
      ) || 0;
    const childFare =
      parseFloat(
        (Number(values?.CHILD?.afC?.NCM?.OT) +
          (tripType == "1" ? 0 : valuesReturn?.CHILD?.afC?.NCM?.OT)) *
          paxInfo?.CHILD,
      ) || 0;
    const infantFare =
      parseFloat(
        (Number(values?.INFANT?.afC?.NCM?.OT) +
          (tripType == "1" ? 0 : valuesReturn?.INFANT?.afC?.NCM?.OT)) *
          paxInfo?.INFANT,
      ) || 0;

    const totalFare = Number(adultFare + childFare + infantFare).toFixed(2);
    return Number(totalFare);
  };

  const totalTdsForTJ = (values, tripType, valuesReturn, paxInfo) => {
    const adultFare =
      parseFloat(
        (Math.abs(values?.ADULT?.afC?.NCM?.TDS) +
          (tripType == "1"
            ? 0
            : Math.abs(valuesReturn?.ADULT?.afC?.NCM?.TDS))) *
          paxInfo?.ADULT,
      ) || 0;
    const childFare =
      parseFloat(
        (Math.abs(values?.CHILD?.afC?.NCM?.TDS) +
          (tripType == "1"
            ? 0
            : Math.abs(valuesReturn?.CHILD?.afC?.NCM?.TDS))) *
          paxInfo?.CHILD,
      ) || 0;
    const infantFare =
      parseFloat(
        (Math.abs(values?.INFANT?.afC?.NCM?.TDS) +
          (tripType == "1"
            ? 0
            : Math.abs(valuesReturn?.INFANT?.afC?.NCM?.TDS))) *
          paxInfo?.INFANT,
      ) || 0;

    const totalFare = Number(adultFare + childFare + infantFare).toFixed(2);
    return Number(totalFare);
  };
  const totalDiscountOnward = (values) => {
    const adultDiscount =
      values.adults * Number(values.onwardAdultDiscount) || 0;
    const infantDiscount =
      values.infant * Number(values.onwardInfantDiscount) || 0;
    const childDiscount =
      values.child * Number(values.onwardChildDiscount) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };
  const totalDiscountReturn = (values) => {
    const adultDiscount =
      values.adults * Number(values.returnAdultDiscount) || 0;
    const infantDiscount =
      values.infant * Number(values.returnInfantDiscount) || 0;
    const childDiscount =
      values.child * Number(values.returnChildDiscount) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };
  const totalDiscountOnwardWithGST = (values) => {
    const adultDiscount =
      values.adults * Number(values.onwardAdultDiscountWithGst) || 0;
    const infantDiscount =
      values.infant * Number(values.onwardInfantDiscountWithGst) || 0;
    const childDiscount =
      values.child * Number(values.onwardChildDiscountWithGst) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };
  const totalDiscountReturnWithGST = (values) => {
    const adultDiscount =
      values.adults * Number(values.returnAdultDiscountWithGst) || 0;
    const infantDiscount =
      values.infant * Number(values.returnInfantDiscountWithGst) || 0;
    const childDiscount =
      values.child * Number(values.returnChildDiscountWithGst) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };
  const totalGstCommOnward = (values) => {
    const adultDiscount = values.adults * Number(values.onwardAdultGSTAmt) || 0;
    const infantDiscount =
      values.infant * Number(values.onwardInfantGSTAmt) || 0;
    const childDiscount = values.child * Number(values.onwardChildGSTAmt) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };
  const totalGstCommReturn = (values) => {
    const adultDiscount = values.adults * Number(values.returnAdultGSTAmt) || 0;
    const infantDiscount =
      values.infant * Number(values.returnInfantGSTAmt) || 0;
    const childDiscount = values.child * Number(values.returnChildGSTAmt) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };
  const totalTdsOnward = (values) => {
    const adultDiscount = values.adults * Number(values.onwardAdultTds) || 0;
    const infantDiscount = values.infant * Number(values.onwardInfantTds) || 0;
    const childDiscount = values.child * Number(values.onwardChildTds) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };
  const totalTdsReturn = (values) => {
    const adultDiscount = values.adults * Number(values.returnAdultTds) || 0;
    const infantDiscount = values.infant * Number(values.returnInfantTds) || 0;
    const childDiscount = values.child * Number(values.returnChildTds) || 0;
    const totalDiscount = Number(
      adultDiscount + infantDiscount + childDiscount,
    ).toFixed(2);
    return totalDiscount;
  };

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };
  const checkIfInvalid = (name, touched, errors) => {
    return touched[name] && errors[name];
  };


  return (
    <>
      <Helmet>
        <title>Offline Ticket</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Offline Ticket" }]}></Breadcrumb>
      <Formik
        onSubmit={submitForm}
        initialValues={state.model}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          isValid,
          dirty,
          setFieldValue,
        }) => {
          return (
            <>
              <form
                className="needs-validation"
                onSubmit={handleSubmit}
                noValidate
              >
                <SimpleCard className="mb-2">
                  <div className="row">
                    <div className="col-md-12 col-12">
                      <label>
                        Affiliate Name <span className="text-danger">*</span>
                      </label>
                      {/* {JSON.stringify(affiliateResponse)} */}
                      <MemberSearchOfflineTicket
                        setAffiliateResponse={setAffiliateResponse}
                        setFieldValue={setFieldValue}
                        memId={state.affiliateName}
                        handleChangeOptions={(memId) => {
                          setFieldValue("affiliateName", memId);
                          setState((prevState) => ({
                            ...prevState,
                            memId,
                          }));
                        }}
                        name="memId"
                        value={values.memId}
                      />
                      {values.balance && (
                        <div style={{ color: "red", fontWeight: "bold" }}>
                          Wallet Balence : ₹ {Number(values.balance).toFixed(2)}
                        </div>
                      )}
                      {checkIfInvalid("affiliateName", touched, errors) && (
                        <div style={{ fontSize: "10px", color: "red" }}>
                          {errors.affiliateName}
                        </div>
                      )}
                    </div>
                    {/* <div className="col-md-6 col-12">
                      <span>
                        <RenderSelectInput
                          name="service"
                          placeholder="Affiliate Service"
                          display="Affiliate Service"
                          value={values.service}
                          items={affiliateService}
                          error={errors.service}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          touched={touched.service}
                        ></RenderSelectInput>
                      </span>
                    </div> */}
                  </div>
                </SimpleCard>
                <div className="row">
                  <div className="col-12 ">
                    <SimpleCard className="mb-2">
                      <Row className="form-row">
                        <Col>
                          <RenderSelectInput
                            name="tripType"
                            display="Journey Type"
                            value={values?.tripType}
                            items={tripTypeOptions}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            touched={touched.tripType}
                            error={errors.tripType}
                            required
                          ></RenderSelectInput>
                        </Col>
                        <Col>
                          <RenderSelectInput
                            name="flightType"
                            display="Flight Type"
                            value={values.flightType}
                            items={flightTypeOptions}
                            error={errors.flightType}
                            onChange={(e) => {
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            touched={touched.flightType}
                            required
                          ></RenderSelectInput>
                        </Col>
                        {/* <Col>
                          <label style={{ fontWeight: "bold" }}>
                            Booking Id
                          </label>
                          <RenderTextInput
                            name="bookingId"
                            // display="Affiliate Service"
                            placeholder="Booking Id"
                            value={"System generated"}
                            readOnly
                            // value={values?.bookingId}
                            // error={errors.bookingId}
                            // onChange={(e) => {
                            //   handleChange(e);
                            // }}
                            // onBlur={handleBlur}
                            // touched={touched.bookingId}
                          ></RenderTextInput>
                        </Col>
                        <Col>
                          <label style={{ fontWeight: "bold" }}>Ref. No.</label>
                          <RenderTextInput
                            name="bookingReferenceNumber"
                            placeholder="Ref. No."
                            value={"System generated"}
                            readOnly
                            // value={values?.bookingReferenceNumber}
                            // error={errors.bookingReferenceNumber}
                            // onChange={(e) => {
                            //   handleChange(e);
                            // }}
                            // onBlur={handleBlur}
                            // touched={touched.bookingReferenceNumber}
                          ></RenderTextInput>
                        </Col> */}
                        <Col lg={12} className="text-info">
                          System Assigned Booking ID & Ref. No.
                        </Col>
                      </Row>
                    </SimpleCard>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 col-12">
                    <SimpleCard title="Markup" className="mb-2">
                      <Row style={{ marginLeft: 5 }}>
                        <Col xs="12" md="6" lg={"6"}>
                          <RenderTextInput
                            type="number"
                            display="Admin"
                            name="adminMarkup"
                            value={values.adminMarkup}
                            // value={
                            //       Number(values.adminMarkup || 0) === 0
                            //         ? 11.80
                            //         : values.adminMarkup
                            //     }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.adminMarkup}
                            touched={touched.adminMarkup}
                            required
                            disabled
                          ></RenderTextInput>
                        </Col>
                        <Col xs="12" md="6" lg={"6"}>
                          <RenderTextInput
                            type="number"
                            display="User"
                            name="userMarkup"
                            value={values.userMarkup}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.userMarkup}
                            touched={touched.userMarkup}
                            required
                          ></RenderTextInput>
                        </Col>
                      </Row>
                    </SimpleCard>
                  </div>
                  <div className="col-md-6 col-12">
                    <SimpleCard title="Pax Number" className="mb-2">
                      <Row style={{ marginLeft: 5 }}>
                        <Col xs="12" md="4" lg={"4"}>
                          <RenderTextInput
                            type="number"
                            name="adults"
                            display="Adults"
                            placeholder="Number Of Adults"
                            value={values.adults}
                            error={errors.adults}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.adults}
                            required
                          ></RenderTextInput>
                        </Col>
                        <Col xs="12" md="4" lg={"4"}>
                          <RenderTextInput
                            type="number"
                            display="Child"
                            name="child"
                            value={values.child}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.child}
                            touched={touched.child}
                            required
                          ></RenderTextInput>
                        </Col>
                        <Col xs="12" md="4" lg={"4"}>
                          <RenderTextInput
                            type="number"
                            display="Infant"
                            name="infant"
                            value={values.infant}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.infant}
                            touched={touched.infant}
                            required
                          ></RenderTextInput>
                        </Col>
                      </Row>
                    </SimpleCard>
                  </div>
                  <div className="col-md-12 col-12">
                    <SimpleCard title="Supplier Name" className="mb-2">
                      <Row style={{ marginLeft: 5 }}>
                        <Col xs="12" md="12" lg={"12"}>
                          <RenderTextInput
                            type="text"
                            name="supplierName"
                            display="Supplier Name"
                            placeholder="Supplier Name"
                            value={values.supplierName}
                            error={errors.supplierName}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            touched={touched.supplierName}
                            required
                          ></RenderTextInput>
                        </Col>
                      </Row>
                    </SimpleCard>
                  </div>

                  <div className="row">
                    <Col
                      md={
                        values.tripType == 2 || values.tripType == 3
                          ? "6"
                          : "12"
                      }
                    >
                      <Card className="p-4 mb-4 border">
                        <Card.Title className="mb-3 titleMain">
                          Onward Flight
                        </Card.Title>

                        <FieldArray
                          name="flightLegs.onward"
                          render={(arrayHelpers) => (
                            <>
                              {values?.flightLegs?.onward &&
                              Object.keys(
                                values?.flightLegs?.onward != null &&
                                  values?.flightLegs?.onward,
                              )?.length > 0
                                ? values?.flightLegs?.onward.map(
                                    (leg, index, array) => (
                                      <div key={index} className="">
                                        <FlightLegs
                                          array={array}
                                          index={index}
                                          arrayHelpers={arrayHelpers}
                                          values={values}
                                          touched={touched}
                                          errors={errors}
                                          handleChange={handleChange}
                                          tripType={values?.tripType}
                                          setFieldValue={setFieldValue}
                                        />
                                        {/* {JSON.stringify(
                                          console.log(
                                            values?.flightLegs?.onward
                                          )
                                        )} */}
                                      </div>
                                    ),
                                  )
                                : ""}
                              <div className="d-flex justify-content-end">
                                <Button
                                  className="mb-4"
                                  variant="primary"
                                  type="button"
                                  onClick={() => {
                                    arrayHelpers.push({
                                      airline: "",
                                      // supplier: "",
                                      pnr: "",
                                      airportDepartureId: "",
                                      airportDestinationId: "",
                                      arrivalDate: "",
                                      departureDate: "",
                                      arrivalTime: "",
                                      departureTime: "",
                                      fN: "",
                                      // ticketNo: "",
                                      gdsPnr: "",
                                      airportDepartureTerminal: "",
                                      airportDestinationTerminal: "",
                                    });
                                  }}
                                >
                                  <MdOutlineAdd size={20} />
                                </Button>
                              </div>
                            </>
                          )}
                        />
                      </Card>
                    </Col>
                    {(values.tripType == 2 || values.tripType == 3) && (
                      <Col md="6">
                        <Card className="p-4 mb-4">
                          <Card.Title className="mb-3 titleMain">
                            Return Flight
                          </Card.Title>

                          <FieldArray
                            name="flightLegs.return"
                            render={(arrayHelpers) => (
                              <>
                                {values?.flightLegs?.return ||
                                Object.keys(
                                  values?.flightLegs?.return != null &&
                                    values?.flightLegs?.return,
                                ).length > 0
                                  ? values?.flightLegs?.return.map(
                                      (leg, index, array) => (
                                        <div key={index}>
                                          <FlightLegsReturn
                                            array={array}
                                            index={index}
                                            arrayHelpers={arrayHelpers}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                            tripType={values?.tripType}
                                            setFieldValue={setFieldValue}
                                          />
                                        </div>
                                      ),
                                    )
                                  : ""}

                                <Row>
                                  <Col className="d-flex justify-content-end">
                                    <Button
                                      className="mb-4 "
                                      variant="primary"
                                      type="button"
                                      onClick={() => {
                                        arrayHelpers.push({
                                          airline: "",
                                          // supplier: "",
                                          pnr: "",
                                          airportDepartureId: "",
                                          airportDestinationId: "",
                                          arrivalDate: "",
                                          departureDate: "",
                                          arrivalTime: "",
                                          departureTime: "",
                                          fN: "",
                                          // ticketNo: "",
                                          gdsPnr: "",
                                          airportDepartureTerminal: "",
                                          airportDestinationTerminal: "",
                                        });
                                      }}
                                    >
                                      <MdOutlineAdd size={20} />
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            )}
                          />
                        </Card>
                      </Col>
                    )}
                  </div>

                  {/* // pax details start */}
                  <div className="row">
                    <Col
                      md={
                        values.tripType == 2 || values.tripType == 3
                          ? "6"
                          : "12"
                      }
                    >
                      <Card className="p-4 mb-4 border">
                        <Card.Title className="mb-3 titleMain">
                          Pax Details
                        </Card.Title>

                        <FieldArray
                          name="pax.onward"
                          render={(arrayHelpers) => (
                            <>
                              {values?.pax?.onward &&
                              Object.keys(values?.pax.onward).length > 0
                                ? values?.pax?.onward.map(
                                    (leg, index, array) => (
                                      <div key={index} className="">
                                        <PaxCard
                                          calculateSSRAmount={
                                            calculateSSRAmount
                                          }
                                          array={array}
                                          index={index}
                                          arrayHelpers={arrayHelpers}
                                          values={values}
                                          touched={touched}
                                          errors={errors}
                                          handleChange={handleChange}
                                          handleBlur={handleBlur}
                                          tripType={values?.tripType}
                                          setFieldValue={setFieldValue}
                                        />
                                      </div>
                                    ),
                                  )
                                : ""}

                              <div className="d-flex justify-content-end">
                                <Button
                                  className="mb-4"
                                  variant="primary"
                                  type="button"
                                  onClick={() => {
                                    arrayHelpers.push({
                                      pt: "ADULT",
                                      ti: "Mr",
                                      fN: "",
                                      lN: "",
                                      food: [],
                                      fast: [],
                                      extraBag: [],
                                      seat: [],
                                      Wheelchair: false,
                                      refundable: 1,
                                      checkingBag: "",
                                      cabinBag: "",
                                      cc: "ECONOMY",
                                      cB: "",
                                      pNat: "",
                                      dob: "",
                                      pNum: "",
                                      eD: "",
                                      pid: "",
                                      ticketNo: "",
                                      ff: "",
                                    });
                                  }}
                                >
                                  <MdOutlineAdd size={20} />
                                </Button>
                              </div>
                            </>
                          )}
                        />
                      </Card>
                    </Col>

                    {(values.tripType == 2 || values.tripType == 3) && (
                      <Col md="6">
                        <Card className="p-4 mb-4 border">
                          <Card.Title className="mb-3 titleMain">
                            Pax Details
                          </Card.Title>

                          <FieldArray
                            name="pax.return"
                            render={(arrayHelpers) => (
                              <>
                                {values?.pax?.return &&
                                Object.keys(values?.pax?.return).length > 0
                                  ? values?.pax?.return.map(
                                      (leg, index, array) => (
                                        <div key={index} className="">
                                          <PaxCardReturn
                                            calculateSSRAmount={
                                              calculateSSRAmount
                                            }
                                            array={array}
                                            index={index}
                                            arrayHelpers={arrayHelpers}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            tripType={values?.tripType}
                                            setFieldValue={setFieldValue}
                                          />
                                        </div>
                                      ),
                                    )
                                  : ""}

                                <div className="d-flex justify-content-end">
                                  <Button
                                    className="mb-4"
                                    variant="primary"
                                    type="button"
                                    onClick={() => {
                                      arrayHelpers.push({
                                        pt: "ADULT",
                                        ti: "Mr",
                                        fN: "",
                                        lN: "",
                                        food: [],
                                        fast: [],
                                        extraBag: [],
                                        seat: [],
                                        Wheelchair: false,
                                        refundable: 1,
                                        checkingBag: "",
                                        cabinBag: "",
                                        cc: "ECONOMY",
                                        cB: "",
                                        pNat: "",
                                        dob: "",
                                        pNum: "",
                                        eD: "",
                                        pid: "",
                                        ticketNo: "",
                                        ff: "",
                                      });
                                    }}
                                  >
                                    <MdOutlineAdd size={20} />
                                  </Button>
                                </div>
                              </>
                            )}
                          />
                        </Card>
                      </Col>
                    )}
                  </div>
                  <div className="row">
                    <Col
                      md={
                        values.tripType == 2 || values.tripType == 3
                          ? "6"
                          : "12"
                      }
                    >
                      <Card className="p-4 mb-4 border">
                        <Card.Title className="mb-3 titleMain">
                          <h4>Onward Pax Price</h4>
                        </Card.Title>

                        <PriceCard
                          touched={touched}
                          handleBlur={handleBlur}
                          errors={errors}
                          values={values}
                          handleChange={handleChange}
                          tripType={values.tripType}
                          setFieldValue={setFieldValue}
                        />
                      </Card>
                    </Col>
                    {(values.tripType == 2 || values.tripType == 3) && (
                      <Col>
                        <Card className="p-4 mb-4 border">
                          <Card.Title className="mb-3 titleMain">
                            <h4>Return Pax Price</h4>
                          </Card.Title>
                          <PriceCardReturn
                            touched={touched}
                            handleBlur={handleBlur}
                            errors={errors}
                            values={values}
                            handleChange={handleChange}
                            tripType={values.tripType}
                            setFieldValue={setFieldValue}
                          />
                        </Card>
                      </Col>
                    )}
                  </div>

                  <div className="row">
                    <Col
                      md={
                        values.tripType == 2 || values.tripType == 3
                          ? "6"
                          : "12"
                      }
                    >
                      <Card className="p-4 mb-4 border">
                        <Card.Title className="mb-3 titleMain">
                          Onward Flight Total Discount & TDS & GST
                        </Card.Title>{" "}
                        <Row className="form-row">
                          <Col
                            xs="12"
                            md="6"
                            lg={
                              values.tripType == 2
                                ? "6"
                                : values.tripType == 3
                                  ? "6"
                                  : "3"
                            }
                          >
                            <RenderTextInput
                              readOnly
                              display={"Total Commission without GST"}
                              name="discount"
                              placeholder="Discount"
                              value={totalDiscountOnward(values)}
                            ></RenderTextInput>
                          </Col>
                          <Col
                            xs="12"
                            md="6"
                            lg={
                              values.tripType == 2
                                ? "6"
                                : values.tripType == 3
                                  ? "6"
                                  : "3"
                            }
                          >
                            <RenderTextInput
                              readOnly
                              display={"GST Amount"}
                              name="gstComm"
                              placeholder="Discount"
                              value={totalGstCommOnward(values)}
                            ></RenderTextInput>
                          </Col>
                          <Col
                            xs="12"
                            md="6"
                            lg={
                              values.tripType == 2
                                ? "6"
                                : values.tripType == 3
                                  ? "6"
                                  : "3"
                            }
                          >
                            <RenderTextInput
                              readOnly
                              display={"Total Commission with GST"}
                              name="commWithGst"
                              placeholder="Discount"
                              value={totalDiscountOnwardWithGST(values)}
                            ></RenderTextInput>
                          </Col>

                          <Col
                            xs="12"
                            md="6"
                            lg={
                              values.tripType == 2
                                ? "6"
                                : values.tripType == 3
                                  ? "6"
                                  : "3"
                            }
                          >
                            <RenderTextInput
                              readOnly
                              display={"Total TDS Amount"}
                              name="retTdsAmount"
                              placeholder="Return Flight TDS"
                              value={totalTdsOnward(values)}
                            ></RenderTextInput>
                          </Col>
                          {/* <Col>
                            <RenderTextInput
                              name="gstAmount"
                              display={"GST Amount"}
                              placeholder="GST Amount"
                              value={values?.gstAmount}
                              error={errors.gstAmount}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              touched={touched.gstAmount}
                            ></RenderTextInput>
                          </Col> */}
                        </Row>
                      </Card>
                    </Col>

                    {(values.tripType == 2 || values.tripType == 3) && (
                      <Col md="6">
                        <Card className="p-4 mb-4 border">
                          <Card.Title className="mb-3 titleMain">
                            Return Flight Total Discount & TDS & GST
                          </Card.Title>{" "}
                          <Row className="form-row">
                            <Col
                              xs="12"
                              md="6"
                              lg={
                                values.tripType == 2
                                  ? "6"
                                  : values.tripType == 3
                                    ? "6"
                                    : "3"
                              }
                            >
                              <RenderTextInput
                                readOnly
                                display={"Return Total Commission without GST"}
                                name="discount"
                                placeholder="Discount"
                                value={totalDiscountReturn(values)}
                              ></RenderTextInput>
                            </Col>
                            <Col
                              xs="12"
                              md="6"
                              lg={
                                values.tripType == 2
                                  ? "6"
                                  : values.tripType == 3
                                    ? "6"
                                    : "3"
                              }
                            >
                              <RenderTextInput
                                readOnly
                                display={"Return GST Amount"}
                                name="gstComm"
                                placeholder="Discount"
                                value={totalGstCommReturn(values)}
                              ></RenderTextInput>
                            </Col>
                            <Col
                              xs="12"
                              md="6"
                              lg={
                                values.tripType == 2
                                  ? "6"
                                  : values.tripType == 3
                                    ? "6"
                                    : "3"
                              }
                            >
                              <RenderTextInput
                                readOnly
                                display={"Return Total Commission with GST"}
                                name="commWithGst"
                                placeholder="Discount"
                                value={totalDiscountReturnWithGST(values)}
                              ></RenderTextInput>
                            </Col>

                            <Col
                              xs="12"
                              md="6"
                              lg={
                                values.tripType == 2
                                  ? "6"
                                  : values.tripType == 3
                                    ? "6"
                                    : "3"
                              }
                            >
                              <RenderTextInput
                                readOnly
                                display={"Total TDS Amount"}
                                name="retTdsAmount"
                                placeholder="Return Flight TDS"
                                value={totalTdsReturn(values)}
                              ></RenderTextInput>
                            </Col>
                            {/* <Col>
                            <RenderTextInput
                              name="gstAmount"
                              display={"GST Amount"}
                              placeholder="GST Amount"
                              value={values?.gstAmount}
                              error={errors.gstAmount}
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              onBlur={handleBlur}
                              touched={touched.gstAmount}
                            ></RenderTextInput>
                          </Col> */}
                          </Row>
                        </Card>
                      </Col>
                    )}
                  </div>
                  <div className="row">
                    <Col
                      md={
                        values.tripType == 2 || values.tripType == 3
                          ? "6"
                          : "12"
                      }
                    >
                      <Card className="p-4 mb-4 border">
                        <Card.Title className="mb-3 titleMain">
                          Onward Flight SSR Amount
                        </Card.Title>{" "}
                        <Row className="form-row">
                          <Col>
                            <RenderTextInput
                              readOnly
                              type={"number"}
                              // // display={"Onward Flight SSR Amount"}
                              // name="ssrAmount"
                              placeholder="Amount"
                              value={calculateSSRAmount(values?.pax?.onward)}
                              // error={errors?.ssrAmount}
                              // onChange={handleChange}
                              // onBlur={handleBlur}
                              // touched={touched?.ssrAmount}
                            />
                          </Col>
                        </Row>
                      </Card>
                    </Col>

                    {(values.tripType == 2 || values.tripType == 3) && (
                      <Col md="6">
                        <Card className="p-4 mb-4 border">
                          <Card.Title className="mb-3 titleMain">
                            Return Flight SSR Amount
                          </Card.Title>{" "}
                          <Row className="form-row">
                            <Col>
                              <RenderTextInput
                                type={"number"}
                                readOnly
                                // // display={"Onward Flight SSR Amount"}
                                // name="returnSSRAmount"
                                placeholder="Amount"
                                value={calculateSSRAmount(values?.pax?.return)}
                                // error={errors?.returnSSRAmount}
                                // onChange={handleChange}
                                // onBlur={handleBlur}
                                // touched={touched?.returnSSRAmount}
                              />
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    )}
                  </div>
                  <div className="row mb-2">
                    <Col xs={12} sm={12} md={12} lg={12} className="mb-2">
                      <label>
                        <input
                          className={`form-check-input border-primary`}
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                        />{" "}
                        <span style={{ fontWeight: "bold" }}>
                          I have GST No.
                        </span>
                      </label>
                    </Col>

                    {isChecked && (
                      <Col xs={12} sm={12} md={12} lg={12}>
                        <Card className="p-4 mb-4 border">
                          <Card.Title className="mb-3 titleMain">
                            GST Information
                          </Card.Title>{" "}
                          <Row>
                            <RenderTextInput
                              display={"GST Registered Name"}
                              name="gstInfo.registeredName"
                              placeholder="GST Registered Name"
                              value={values?.gstInfo?.registeredName || ""}
                              error={errors?.gstInfo?.registeredName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched?.gstInfo?.registeredName}
                            />

                            <RenderTextInput
                              display={"GST No."}
                              name="gstInfo.gstNumber"
                              placeholder="GST No."
                              value={values?.gstInfo?.gstNumber || ""}
                              error={errors?.gstInfo?.gstNumber}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched?.gstInfo?.gstNumber}
                            />

                            <RenderTextInput
                              display={"GST Email Id"}
                              name="gstInfo.email"
                              placeholder="GST Email Id"
                              value={values?.gstInfo?.email || ""}
                              error={errors?.gstInfo?.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched?.gstInfo?.email}
                            />

                            <RenderTextInput
                              display={"GST Mobile No."}
                              name="gstInfo.mobile"
                              placeholder="GST Mobile No."
                              value={values?.gstInfo?.mobile || ""}
                              error={errors?.gstInfo?.mobile}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched?.gstInfo?.mobile}
                            />

                            <RenderTextInput
                              display={"GST Address"}
                              name="gstInfo.address"
                              placeholder="GST Address"
                              value={values?.gstInfo?.address || ""}
                              error={errors?.gstInfo?.address}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              touched={touched?.gstInfo?.address}
                            />
                          </Row>
                        </Card>
                      </Col>
                    )}
                  </div>

                  {/* // pax details end */}
                </div>

                {canAdd && (
                  <LaddaButton
                    // disabled={Object.keys(errors).length !== 0}
                    loading={isSubmitting}
                    data-style={ZOOM_IN}
                    className="btn btn-primary mb-3"
                    type="submit"
                    // type="button"
                    // onClick={() => submitForm(values)}
                  >
                    Preview & Book
                  </LaddaButton>
                )}
                <PreviewModal
                  calculateSSRAmount={calculateSSRAmount}
                  offlineBooking={offlineBooking}
                  response={response}
                  show={show}
                  setShow={setShow}
                  values={values}
                  isLoading={isLoading}
                  affiliateResponse={affiliateResponse}
                />
              </form>
            </>
          );
        }}
      </Formik>
    </>
  );
};

export default AddTicket;
